import type { CurrentUser } from '@occ/contracts';
import { useGetIdentity } from '@refinedev/core';
import { useBranding } from '../../branding/BrandingProvider';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from '../ui/sidebar';
import { NavGroup } from './nav-group';
import { NavUser } from './nav-user';
import { NodeSwitcher } from './node-switcher';
import { sidebarData } from './sidebar-data';

/**
 * El sidebar entero del panel, compuesto — mismo reparto que
 * `app-sidebar.tsx` de shadcn-admin: cabecera (marca + selector), contenido
 * (grupos de navegación) y pie (cuenta). `NodeSwitcher` ocupa el lugar del
 * "team switcher" de la plantilla, pero la marca del tenant necesita su
 * propia fila encima — a diferencia de un dashboard genérico, el OCC hace
 * white-label real (RF-21) y el logo/nombre del tenant tiene que verse
 * siempre, no solo dentro del selector.
 */
export function AppSidebar() {
  const { branding } = useBranding();
  const { data: user } = useGetIdentity<CurrentUser>();

  return (
    <Sidebar>
      <SidebarHeader>
        <div className="flex items-center gap-2 px-2 py-1 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0">
          {branding.logoUrl && (
            <img src={branding.logoUrl} alt="" className="h-6 w-auto max-w-[8rem] shrink-0" />
          )}
          <span className="truncate text-sm font-semibold tracking-tight group-data-[collapsible=icon]:hidden">
            {branding.productName || 'Omnia Control Center'}
          </span>
        </div>
        <NodeSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {sidebarData.navGroups.map((group) => (
          <NavGroup key={group.title} {...group} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
